// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.90.1-beta.85f0edd9e',
  revision: '85f0edd9e',
  branch: 'develop',
  date: 'Mon, 21 Sep 2026 13:11:08 GMT'
};